import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { AuthService } from 'shared/core/data-access/auth';
import { ColorEnum } from 'shared/design-system/data-access/theme';
import { ColumnComponent } from 'shared/design-system/ui/layout';
import { SpinnerComponent } from 'shared/design-system/ui/spinner';
import { TextComponent } from 'shared/design-system/ui/typography';

@Component({
    imports: [RouterOutlet, ColumnComponent, SpinnerComponent, TextComponent],
    selector: 'it-root',
    templateUrl: './root.component.html',
    styleUrls: ['./root.component.scss'],
})
export class RootComponent {
    #authService = inject(AuthService);

    ColorEnum = ColorEnum;

    get loadingUserinfo() {
        return this.#authService.loadingUserInfo;
    }
}
